import {
  createRef,
  FC,
  Fragment,
  MutableRefObject,
  useCallback,
  useContext,
} from "react";
import { Role } from "../../../../../../domain/user/Role";
import { IconButton, Table } from "rsuite";
import { TableInstance } from "rsuite/esm/Table";
import { useTableSize, useTableWidth } from "../../../../../../hook/width";
import { TableHeaderStyleSecondary } from "../../../../../components/table/style";
import { EmptyState } from "../../../../../components/state/empty";
import { faAdd, faGear } from "@fortawesome/free-solid-svg-icons";
import { FaIcon } from "../../../../../components/fontawesome/icon";

import { TableColumnContext } from "../../../../../context/TableContext";
import { ShiftTableColumns } from "../../../../../../schema/table/ShiftTable";
import { ShiftTableName } from "../../../../operator/shift/components/table";
import { useDataPager } from "../../../../../../hook/pager";
import { AttendancePair } from "../../../../../../domain/attendance/Attendance";

type Props = {
  userAttendanceList?: AttendancePair[];
  data: Role[] | undefined;
  loading: boolean;
  selectedItems: string[];
  onSelect: (item: AttendancePair) => void;
  onPreviewClicked: (item: AttendancePair) => void;
  onSelectAllSwitch: () => void;
  onCreateClick: () => void;
  onItemSelectSwitch: (reference: string) => void;
};

export const UserRoleTable: FC<Props> = ({
  userAttendanceList,
  data,
  onSelect,
  onPreviewClicked,
  onCreateClick,
}) => {
  const actionRef = createRef<string | null>() as MutableRefObject<
    string | null
  >;
  const tableRef = createRef<TableInstance<any, any>>();
  const tableSize = useTableSize(tableRef);

  const { partialData } = useDataPager({
    id: `user_attendance_table_${ShiftTableName}`,
    items: userAttendanceList,
  });

  const tableContext = useContext(TableColumnContext);
  const tablePreferences =
    tableContext.getTablePreferences<ShiftTableColumns>(ShiftTableName);

  /*const tableColumnsRelation = useTableWidth(tableRef, {
    0: {
      actions: 0.2,
      label: 0.8,
    },
    800: {
      actions: 0.05,
      label: 0.95,
    },
  });*/
  const onRowSelect = useCallback(
    (item: AttendancePair) => {
      if (actionRef.current) onPreviewClicked(item);
      else onSelect(item);
      actionRef.current = null;
    },
    [partialData]
  );

  return (
    <Fragment>
      <Table
        className={"rounded-xl shadow overflow-hidden"}
        cellBordered
        //loading={loading}
        onRowClick={onRowSelect as any}
        data={data}
        ref={tableRef}
        autoHeight
        renderEmpty={() => (
          <EmptyState
            title={"No hay cargos de usuario"}
            message={"Sin cargos de usuario"}
            icon={faGear}
            footer={
              <div
                className={
                  "flex flex-row text-md items-center justify-center flex-wrap gap-x-2"
                }
              >
                Presiona{" "}
                <IconButton
                  onClick={onCreateClick}
                  appearance={"primary"}
                  size={"xs"}
                  icon={<FaIcon icon={faAdd} size={"xs"} />}
                >
                  Nuevo
                </IconButton>
                para añadir un cargo.
              </div>
            }
          />
        )}
      >
        {tablePreferences
          .filter((column) => column.name) // Filtrar columnas vacías
          .map((column) => {
            switch (column.name) {
              /*case "description":
                return (
                  <Table.Column
                    width={tableSize.calculateWeight(0.45)}
                    onResize={(nSize) => {
                      if (nSize !== undefined) {
                        tableContext.updateTableColumnWeight(
                          ShiftTableName,
                          column.name,
                          tableSize.sizeToWeight(nSize)
                        );
                      }
                    }}
                  >
                    <Table.HeaderCell style={TableHeaderStyleSecondary}>
                      Descripción
                    </Table.HeaderCell>
                    <Table.Cell dataKey={"description"} />
                  </Table.Column>
                );*/
              case "label":
                return (
                  <Table.Column
                    width={tableSize.calculateWeight(1)}
                    onResize={(nSize) => {
                      if (nSize !== undefined) {
                        tableContext.updateTableColumnWeight(
                          ShiftTableName,
                          column.name,
                          tableSize.sizeToWeight(nSize)
                        );
                      }
                    }}
                  >
                    <Table.HeaderCell style={TableHeaderStyleSecondary}>
                      Nombre
                    </Table.HeaderCell>
                    <Table.Cell dataKey={"label"} />
                  </Table.Column>
                );
            }
          })}
      </Table>
    </Fragment>
  );
};
